export const Work = [
    {
        id:1,
        name:"Delta Landing  Page",
        description:"Delta landing page design made by using styled components and framer motion for animation.",
        tags:["react","framer-motion","react-router","styledComponents"],
        
        demo:"https://data-dump-delta.netlify.app/",
        github:"https://github.com/ay690/delta"
    },
    {
        id:2,
        name:"Esignify",
        description:"Design a landing page with styled components and incorporate Framer Motion for captivating animations.",
        tags:["react","framer-motion","styledComponents","react-router"],
        
        demo:"https://esignify.netlify.app/",
        github:"https://github.com/ay690/esignify"
        
    },
    {
        id:3,
        name:"Redux-Toolkit E-comm",
        description:"Created a straightforward e-commerce price and quantity listing page using Redux Toolkit.",
        tags:["react","api", "axios", "redux-toolkit"],
        
        demo:"https://aniket-ecom.netlify.app/",
        github:"https://github.com/ay690/ecom"
    },
    {
        id:4,
        name:"Real Estate properties",
        description:"A Real estate website build in ReactJS. With searching and filtering functionalities.",
        tags:["react","tailwind","react-router"],
        
        demo:"https://eastery-real-estate.netlify.app/",
        github:"https://github.com/ay690/filter_prop"
       
    },{
        id:5,
        name:"Netflix Clone",
        description:"Craft a Netflix-inspired home screen by utilizing HTML, CSS, and JavaScript to bring captivating animations to life.",
        tags:["HTML", "CSS", "JS"],
        
        demo:"https://ay690.github.io/Netflix_clone/",
        github:"https://github.com/ay690/Netflix_clone"
        
    },
    {
        id:6,
        name:"Mercor Dashboard Page",
        description:"A reponsive dashboard design that has drag and drop feature for mercor making use of vite and tailwind as a css library.",
        tags:["react","react-router","figma","css","tailwind","vite","react-beautiful-dnd"],
        
        demo:" https://kanban-mercor.netlify.app/",
        github:"https://github.com/ay690/kanban-mercor"
        
    },
    
  
] 